'use strict';

angular.module('atex.dam').config(function($compileProvider, $httpProvider, uiSelectConfig, $stateProvider, $urlRouterProvider, $provide, pollerConfig) {
  uiSelectConfig.theme = 'select2';
  $httpProvider.interceptors.push('authInterceptor');

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|file|blob:chrome-extension):|data:image|\//);

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('list', {
      url: '/',
      templateUrl: 'views/dam-list.html',
      controller:'DamListController',
      resolve: {
        'configuration-default' : function(configuration) {
          return configuration.whenReady();
        },
        'preload-factory' : function(PreloadService) {
          return PreloadService.preloadFactoryList('deskList');
        }
      }
  }).state('search', {
    url: '/search/:type/:query',
    resolve: {
      'configuration-default' : function(configuration) {
        return configuration.whenReady();
      },
      'preload-factory' : function(PreloadService) {
        return PreloadService.preloadFactoryList('deskList');
      }
    }
  }).state('list.link', {
    url: 'embed/:op/:id?',
    views: {
      'childView': {
        templateUrl: 'views/dam-embed-view.html',
        controller: 'EmbedViewController'
      }
    }
  }).state('list.collection', {
    url: 'collection/:id/:preview?/:templateId?/:customSaveTitle?',
    views: {
      'childView': {
        templateUrl: 'views/dam-collection.html',
        controller: 'DamCollectionController'
      }
    },
    params: { postActionCallback: undefined }
  }).state('list.relations', {
    url: 'relations/:id',
    views: {
      'childView': {
        templateUrl: 'views/dam-relations.html',
        controller: 'DamRelationsController',
      }
    }
  }).state('list.related', {
    url: 'related/:id?',
    views: {
      'childView': {
        templateUrl: 'views/dam-relations.html',
        controller: 'DamRelatedController',
      }
    },
    params: { references: { array: true } }
  }).state('list.jobs',{
    url: 'jobs/:id',
    views: {
      'childView': {
        templateUrl: 'views/dam-related-jobs.html',
        controller: 'DamRelatedJobsController',
      }
    }
  }).state('list.page', {
    url: 'page/:id/:partition?',
    views: {
      'childView': {
        templateUrl: 'views/dam-page-viewer.html',
        controller: 'DamPageViewerController',
      }
    }
  }).state('list.edit', {
    url: 'edit/:id?/:isEditAll?/:templateId?/:customSaveTitle?',
    views: {
      'childView': {
        templateUrl: 'views/dam-edit.html',
        controller: 'DamEditController'
      }
    },
    params: { ids: { array: true }, postActionCallback: undefined }
  }).state('list.preview', {
    url: 'preview/:id',
    views: {
      'childView': {
        templateUrl: 'views/dam-preview/dam-preview.html',
        controller: 'DamPreviewController'
      }
    }
  }).state('list.versions', {
    url: 'versions/:id',
    views: {
      'childView': {
        templateUrl: 'views/dam-versions.html',
        controller: 'DamVersionsController'
      }
    }
  }).state('list.versions.preview', {
    url: 'preview/:id?version',
    views: {
      'childVersionView': {
        templateUrl: 'views/dam-preview/dam-preview.html',
        controller: 'DamPreviewController'
      }
    }
  }).state('list.lockeditems', {
    url: 'locked',
    views: {
      'childView': {
        templateUrl: 'views/dam-locked-items-list.html',
        controller: 'DamLockedItemsListController',
      }
    },
    params: { collectionId: null, items: { array: true } }
  }).state('list.engagements',{
    url: 'engagements',
	views: {
	  'childView': {
	    templateUrl: 'views/dam-engagements.html',
	    controller: 'DamEngagementViewController',
	  }
	},
	params: { items: { array: true } }
  }).state('list.extedit', {
    url: 'ext-edit/:id',
    views: {
	  'childView': {
	    controller: 'DamEditByIdController'
	  }
	}
  }).state('list.contents',{
    url: 'contents',
    views: {
      'childView': {
        templateUrl: 'views/dam-list-contents.html',
        controller: 'DamListContentViewController'
      }
    },
    params: { items: { array: true } }
  }).state('list.jsoncompare',{
    url: 'jsoncompare',
    views: {
      'childView': {
        templateUrl: 'views/dam-json-compare.html',
        controller: 'DamJsonCompareController'
      }
    }
  });

  $httpProvider.interceptors.push('thublistRowTemplateInterceptor');

  // This will extend the onecmsContentEditor scope to be able to use extScope
  $provide.decorator('onecmsContentEditorDirective', ['$delegate', function($delegate) {
    var directive = $delegate[0];
    directive.$$isolateBindings['extScope'] = {
      attrName: 'extScope',
      mode: '=',
      optional: true
    };
    return $delegate;
  }]);

  pollerConfig.handleVisibilityChange = true;

}).config(['$translateProvider', function ($translateProvider) {
  $translateProvider.useLoader( 'DamLocalizationLoaderService', {
    prefix: 'locale/locale-',
    suffix: '.json'
  });
  $translateProvider.registerAvailableLanguageKeys(['de', 'dk', 'en', 'es', 'it', 'nl', 'no', 'sv', 'vi', 'tr'], {
    'de_*': 'de',
    'dk_*': 'dk',
    'en_*': 'en',
    'es_*': 'es',
    'it_*': 'it',
    'nl_*': 'nl',
    'no_*': 'no',
    'sv_*': 'sv',
    'vi_*': 'vi',
    'tr_*': 'tr',

    '*':'en'
  });
  $translateProvider.useSanitizeValueStrategy(null);
}]).run(function($rootScope, $state, AuthenticationService, AuthenticationDialog, DamConfigurationService, DamService, $injector,DamQueryService, DamLocalizationService, $http, $templateCache, $window, ApplicationConfigurationService,UIConfigurationService) {
  // This is the first thing to do in the run, don't add anything before
  $rootScope.$on('onecms:authenticationRequest', function(event, currentUser) {
    if (atex.dam.isTest) {
      return;
    }
    var modal;

    var loginfunc = function(AuthenticationService, AuthenticationDialog) {
      var smodal = AuthenticationDialog.create();
      smodal.whenAuthenticated().then(function() {
        AuthenticationService.confirmAuthenticationRequest();
        AuthenticationService.getCurrentUser().then(function(currentUser) {
          //Login Event
          $window.atex.analytics('set', 'userId', currentUser.principalId);
          $window.atex.analytics('set', 'userName', currentUser.username);
          $window.atex.analytics('event', { e: 'login' });
        });
      }, function() {
        console.log('ERROR: Login modal was cancelled. This can\'t happen. ಠ_ಠ');
      });
      return smodal;
    };
    if (currentUser !== undefined && currentUser.userId !== undefined) {
      modal = AuthenticationDialog.create({
        username : currentUser.username
      });
      modal.whenAuthenticated().then(function() {
        AuthenticationService.confirmAuthenticationRequest();
      }, function() {
        AuthenticationService.cancelAuthenticationRequest();
      });
    } else {
      var username = atex.dam.AngularUtils.getURLParameter("username");
      var authToken = atex.dam.AngularUtils.getURLParameter("token");
      if (!username || !authToken) {
        modal = loginfunc(AuthenticationService, AuthenticationDialog);
      } else {
        AuthenticationService.loginByToken(username, authToken).then(function() {
          AuthenticationService.confirmAuthenticationRequest();
          AuthenticationService.getCurrentUser().then(function(currentUser) {
          });
        }, function() {
          console.log('ERROR: Login token not valid. This can\'t happen. ಠ_ಠ');
          modal = loginfunc(AuthenticationService, AuthenticationDialog);
        });
      }
    }
  });
  ApplicationConfigurationService.getConfigurationFor([ 'statistics' ]).then(function(data) {
    AuthenticationService.getCurrentUser().then(function (currentUser) {
      if (!data) {
        console.error("No statistics server configuration found!");
        return;
      }

      //Login Event
      $window.atex.analytics('set', 'userId', currentUser.principalId);
      $window.atex.analytics('set', 'userName', currentUser.username);
      $window.atex.analytics('create', data.account);
      $window.atex.analytics('set', 'enabled', (data.enabled || false));
      $window.atex.analytics('set', 'url', data.url);
      $window.atex.analytics('set', 'applicationName', data.applicationName);
      $window.atex.analytics('event', {e: 'access'});
    });
  });

  UIConfigurationService.getSearchOptions().then(function (options) {
    $rootScope.searchOptions = options;
  });

  var authToken = atex.dam.AngularUtils.getURLParameter("token");
  if (authToken) {
    AuthenticationService.getCurrentUser().then(function(user) {
      if (user && user.token && user.token !== authToken) {
        $rootScope.$broadcast('onecms:authenticationRequest', undefined);
      }
    });
  }

  var previewId = atex.dam.AngularUtils.getURLParameter("previewid");
  if(previewId){
     DamService.showContentPreview(previewId);
  }

  // set localization translations.
  DamLocalizationService.init();

  // Dynamic queries map with id and timestamp of latest execution
  $rootScope.dynamicQueries = {}; // this one is used to update current
  $rootScope.dynamicQueriesEx = {}; // this one is used to update current

  DamConfigurationService.loadConfiguration();

  $http.get('views/dam-tab-search.html', {
    cache: $templateCache
  });
  $http.get('views/dam-search.html', {
    cache : $templateCache
  });
  $http.get('views/dam-folders-popover.html', {
    cache : $templateCache
  });

  // Configuration service will setup sorting
  $rootScope.sortArray = [ {
    "label" : "Mod.",
    "value" : "modificationTime"
  }, {
    "label" : "Type",
    "value" : "atex_desk_objectType"
  } ];

  $rootScope.damSortData = {
      currentSortValue: "modificationTime",
      currentSortOrderValue: "desc"
  };

  var searchfromURlParam =  function (type, query) {
    /* here we use the injector because injecting directly the DamSearchService in the current run method would cause
    * a premature broadcast of onecms:authenticationRequest (not yet registered)
    */
    $state.go('list'); // First go to list state
    // and use setTimeout to execute the DamSearchService functions after the state switch
    setTimeout(function() {
      var DamSearchService = $injector.get("DamSearchService");
      DamSearchService.clearCurrentAdvQuery();
      if (type === "simple") {
        DamSearchService.simpleSearch(query);
      } else if (type === "advanced") {
        var _query = JSON.parse(query);
        var ts = Date.now();
        DamSearchService.setLastQueryStartTs(ts);
        var extraInfo = {
          queryTs: ts,
          viewMode: _query.viewMode
        };
        DamSearchService.advancedSearch(_query, extraInfo);
      } else if (type === "saved") {
        $rootScope.$broadcast("dam:runSavedQuery", query);
      }
    });
  };

  $rootScope.$on('$stateChangeSuccess', function (event, current, previous) {
    if (current.name === 'search' && previous.type && previous.query) {
      var configuration = $injector.get("configuration");
      var configurationSvc = $injector.get("DamConfigurationService");
      configuration.whenReady().then(function() {
        configurationSvc.loadConfiguration().then(function() {
          searchfromURlParam(previous.type, previous.query);
        });
      });
    }
  });

});

//register the interceptor as a service
angular.module('atex.dam').factory('thublistRowTemplateInterceptor', function($q) {
  return {
    'responseError': function(rejection) {

      if ( !rejection || !rejection.config || !rejection.config.url ) {
        return $q.reject(rejection);
      }
      var isTemplate = !!rejection.config.url.match(/^views\/dam-thumblist-row\/dam-thumblist-row-/g);
      if (isTemplate) {
        rejection.data = '<span class="label label-warning">Please, create the template for the new type (' + rejection.config.url + ')</span>';
        return rejection;
      } else {
        return $q.reject(rejection);
      }
    }
  };
});

angular.module('atex.dam').factory('authInterceptor', function($q, Application, $injector) {
  // Same mapping as onecms-lib in order to correctly use callWithAuthentication
  var HTTPCodeMapping = {
    401: atex.onecms.error.types.AUTHENTICATION_FAILED,
    403: atex.onecms.error.types.PERMISSION_DENIED,
    404: atex.onecms.error.types.NOT_FOUND,
    409: atex.onecms.error.types.CONFLICT,
    500: atex.onecms.error.types.SERVER_ERROR
  };
  var PrintService;
  return {
    'request' : function(config) {
      config.headers = config.headers || {};
      var str = config.url;
      if ( str === undefined || ( str !== undefined && str.indexOf('localapp') === -1 )) {
        config.headers['X-Auth-Token'] = Application.currentUser.token;

        if ( str && str.indexOf('layout/handj') !== -1 ) {
          if (!PrintService) {
            PrintService = $injector.get("PrintService");
          }
          if (PrintService) {
            PrintService.getAuthDetails(config.headers);
          }
        }
      } else {
        config.headers = {};
      }
      return config || $q.when(config);
    },
    'response': function(response) {
       if ( response.headers && response.config && response.config.url && response.config.url.indexOf('layout/handj') !== -1 ) {
        var authLocation = response.headers("X-Auth-Location");
        var authSession = response.headers("X-Auth-Session");

        if (authLocation || authSession) {
          if (!PrintService) {
            PrintService = $injector.get("PrintService");
          }
          if (PrintService) {
            PrintService.setAuthDetails(response.headers);
          }
        }
      }

      // do something on success
      return response;
    },
    'responseError': function(rejection) {
      rejection.type = HTTPCodeMapping[rejection.status];
      return $q.reject(rejection);
    }
  };
});

angular.module('atex.dam').factory('DamService',
function($rootScope, $http, AuthenticationService, Application, SearchService, ContentService, configuration, $q, $modal, $window, $translate, UserProfileService, DamNotificationService) {

  var users;
  var groups;
  var usersAndGroups;
  var currentUserInfo;
  var currentUserDomains;
  var _solrInfo;
  var configurationData = [];

  $rootScope.$on("dam:logout", function() {
    users = undefined;
    groups = undefined;
    usersAndGroups = undefined;
    currentUserInfo = undefined;
    currentUserDomains = undefined;
  });

  var getNotVersionedID = function(contentId) {
    var id_array = contentId.split(".");
    return id_array[0] + "." + id_array[1];
  };

  var getQueryInfo = function() {
    return _.extend({}, configuration.getQueryOptions());
  };

  var getFacetQueryInfo = function() {
    var queryOptions = angular.copy(configuration.getQueryOptions());
    queryOptions.facet = true;

    return _.extend(_.extend({}, queryOptions), configuration.getFacetOptions());
  };

  var getExtraFacetQueryInfo = function() {
    var queryOptions = angular.copy(configuration.getQueryOptions());
    queryOptions.facet = true;

    return _.extend(_.extend({}, queryOptions), configuration.getExtraFacetOptions());
  };

  var getUpdateResultsInfo = function() {
    var queryInfo = getQueryInfo();
    // remove all faceting props
    for (var k in queryInfo) {
      if (k.startsWith('facet')) {
        delete queryInfo[k];
      }
    }
    return queryInfo;
  };

  var boostsObjectType = '^0.000001';
  var allDeskObjType = "article image video audio page graphic collection tweet instagram job embed document liveblog event";
  var emptyQuery = '+atex_desk_objectType:(' + allDeskObjType + ')'+boostsObjectType;

  var getTimestampShift = function() {
    return configuration.getSolrReplicaPollInterval() + 1000;
  };

  var addAtexDeskVersion = function(queryInfo) {
    if (queryInfo.fl) {
      var fl_array = queryInfo.fl.split(',');
      if (fl_array.indexOf("atex_desk_version")<0) {
        queryInfo.fl += ",atex_desk_version";
      }
    } else {
      queryInfo.fl = "atex_desk_version";
    }
  };

  var DamService = {

    getAllDeskObjType: function() {
      return allDeskObjType;
    },

    getBoostsObjType: function() {
      return boostsObjectType;
    },

    getRows: function() {
      var rows = getQueryInfo().rows;
      if (!rows) {
        rows = 50; // default span
      }
      return rows;
    },

    escapeLucene: function(value, faceting) {
      var specials = ['+', '-', '&', '!', '(', ')', '{', '}', '[', ']', '^', '~', ':', '\\', '\''];
      if (faceting) {
        specials.push('"');
      }
      var regexp = new RegExp("(\\" + specials.join("|\\") + ")", "g");
      return value.replace(regexp, "\\$1");
    },
    //This is called to convert a simple query to a advanced query in grid control to add filters in the same query later on.
    getBlankQuery : function(fullText) {
      fullText = DamService.normalizeQueryString(fullText);
      var query = {
       "sortOrderValue" : "desc",
       "sortValue" : "originalCreationTime_dt",
       "_type" : "atex.dam.standard.Query"
      };
      query.name = fullText;
      query.fields = [];

      var stringfield = {};
      stringfield.key = "atex_desk_text";
      stringfield.type = 'STRING';
      stringfield.useId = false;
      stringfield.values = [];
      stringfield.values.push(fullText);
      var typefield = {};
      typefield.key = "atex_desk_objectType";
      typefield.type = 'LIST';
      typefield.useId = false;
      typefield.values = ["article", "image", "page", "video", "audio", "graphic", "collection", "job", "instagram", "tweet", "embed", "document", "liveblog"];
      var boolField = {};
      boolField.key = "physicalPage_ss";
      boolField.type = 'BOOLEAN';
      boolField.useId = false;
      boolField.values = ["false"];

      query.fields.push(stringfield);
      query.fields.push(typefield);
      query.fields.push(boolField);

      return query;

    },
    /*
     * This is called to retrieve result for advanced searches and when the
     * user ask for more results
     *
     * fq parameter: beware FilterQuery it is intended to be used for
     * faceting purposes
     */
     getFilterResults : function(queryData, start, filterQuery, sortBy, sortOrder, dynamicLoadMoreFilterQuery, rows) {
           return DamService.getSolrServerInfo().then(function (solrInfo) {
             var queryInfo = getQueryInfo();

             if (queryData.isDynamic === 'true') {
               addAtexDeskVersion(queryInfo);
             }

             var transferInfo = {};
             for (var k in queryInfo) {
               transferInfo[k] = queryInfo[k];
             }
             transferInfo['core'] = solrInfo.solrCore;

             // If there is no clear indication that we want to query on all the archive
             // we try to use the solrLatestCore if any [max]
             if (solrInfo.solrLatestCore && queryData.onlyLatest) {
               transferInfo['core'] = solrInfo.solrLatestCore;
             }

             if (queryData.solr_query === '') {
               transferInfo['q'] = emptyQuery;
             } else {
               transferInfo['q'] = queryData.solr_query;
             }
             transferInfo['rows'] = DamService.getRows();

             if (queryData.physicalPages === "true") {
               transferInfo.rows = (rows) ? rows : 0;
               transferInfo['variant'] = 'ppage';
             }

             transferInfo['start'] = start;

             // Full Text always filters trash content
             if (queryData.includeTrash === 'true') {
               transferInfo['fq'] = '';
             } else {
               transferInfo['fq'] = configuration.getQueryFilterTrash();
             }

             if (filterQuery) {
               transferInfo['fq'] += filterQuery;
             }

             if (queryData.isDynamic === 'true') {

               if (dynamicLoadMoreFilterQuery) {
                 transferInfo['q'] += dynamicLoadMoreFilterQuery;
               }

               if (configuration.getOnlyNewInDynQuery()) {
                 transferInfo['sort'] = 'originalCreationTime_dt desc';
               } else {
                 // sort desc by modificationTime
                 if (transferInfo.rows > 0) {
                   transferInfo['sort'] = 'atex_desk_version desc';
                 }
               }
             } else if (queryData.physicalPages !== 'true') {
               var _sortBy = sortBy !== undefined ? sortBy : $rootScope.damSortData.currentSortValue;
               var _sortOrder = sortOrder !== undefined ? sortOrder : $rootScope.damSortData.currentSortOrderValue;
               if (_sortBy && _sortOrder) {
                 transferInfo['sort'] = _sortBy + " " + _sortOrder;
               }
             } else if (queryData.physicalPages === 'true') {
               if (transferInfo.rows > 0) {
                 transferInfo['sort'] = ((sortBy !== undefined) ? sortBy : "pageSequence_atex_desk_i") + " " + ((sortOrder !== undefined) ? sortOrder : "asc");
               }
             }

             if (start === 0) {
               transferInfo['trace'] = 'searchAdvanced';
             } else {
               transferInfo['trace'] = 'searchAdvancedMoreResults';
             }
             return UserProfileService.getUserProfile({"application": "desk"}).then(function (configuration) {
               transferInfo.rows = configuration.data['grid-state'].maxRecords;
                if(rows) {
                 transferInfo.rows = rows;
                }
                else if (!transferInfo.rows) {
                 transferInfo.rows = 1000;
                }
                return SearchService.search(transferInfo).then(function (result) {
                  if (queryData.physicalPages === "true" && rows === undefined) {
                    var _rows = atex.onecms.ObjectUtils.getByPath(result, "data/response/numFound");
                    return DamService.getFilterResults(queryData, start, filterQuery, sortBy, sortOrder, dynamicLoadMoreFilterQuery, _rows);
                  } else {
                    return $q.when(result);
                  }
                }).then(null, function (error) {
                  console.log('ERROR: DamService getResults:', error);
                  return $q.reject(error);
                });
             }).then(null, function (error) {
               var message = $translate.getTranslationTable().__PROFILE_ERROR__ + " (" + error.cause + ")";
               DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
             });
           });
         },
    getResults : function(queryData, start, filterQuery, sortBy, sortOrder, dynamicLoadMoreFilterQuery, rows) {
      return DamService.getSolrServerInfo().then(function (solrInfo) {
        // Skip startNewQuery if we are doing a load more for a dyn query
        var isLoadMore = start && start > 0;
        var dynLoadMore = queryData.isDynamic === 'true' && dynamicLoadMoreFilterQuery !== undefined;
        if (start <= 0 && !dynLoadMore) {
          $rootScope.$broadcast("dam:startNewQuery");
          $rootScope.lastAdvQueryData = queryData;
          $rootScope.lastAdvFilterQuery = filterQuery;
          if (queryData.isDynamic !== 'true') {
            $rootScope.lastQueryStartDate = atex.dam.AngularUtils.toUTCDate(Date.now() - getTimestampShift());
          } else {
            $rootScope.lastQueryStartDate = undefined;
          }
        }

        $rootScope.$broadcast("dam:beforeExecuteQuery");

        var queryInfo = getQueryInfo();

        if (queryData.isDynamic === 'true') {
          addAtexDeskVersion(queryInfo);
        }

        var transferInfo = {};
        for (var k in queryInfo) {
          transferInfo[k] = queryInfo[k];
        }
        transferInfo['core'] = solrInfo.solrCore;

        // If there is no clear indication that we want to query on all the archive
        // we try to use the solrLatestCore if any [max]
        if (solrInfo.solrLatestCore && queryData.onlyLatest) {
          transferInfo['core'] = solrInfo.solrLatestCore;
        }

        if (queryData.solr_query === '') {
          transferInfo['q'] = emptyQuery;
        } else {
          transferInfo['q'] = queryData.solr_query;
        }
        transferInfo['rows'] = DamService.getRows();

        if (queryData.budgetView &&  transferInfo['rows'] < 300){
          transferInfo['rows'] = 300;
        }

        if (queryData.physicalPages === "true") {
          transferInfo.rows = (rows) ? rows : 0;
          transferInfo['variant'] = 'ppage';
        }

        transferInfo['start'] = start;

        // Full Text always filters trash content
        $rootScope.includeTrash = queryData.includeTrash;
        if (queryData.includeTrash === 'true') {
          transferInfo['fq'] = '';
        } else {
          transferInfo['fq'] = configuration.getQueryFilterTrash();
        }

        if (filterQuery) {
          transferInfo['fq'] += filterQuery;
        }

        if (queryData.isDynamic === 'true') {

          if (dynamicLoadMoreFilterQuery) {
            transferInfo['q'] += dynamicLoadMoreFilterQuery;
          }

          if (configuration.getOnlyNewInDynQuery()) {
            //sort desc by originalCreationTime_dt
            transferInfo['sort'] = 'originalCreationTime_dt desc';
            $rootScope.damSortData.currentSortValue = 'originalCreationTime_dt';
            $rootScope.damSortData.currentSortOrderValue = 'desc';
          } else {
            // sort desc by modificationTime
            if (transferInfo.rows > 0) {
              transferInfo['sort'] = 'atex_desk_version desc';
              $rootScope.damSortData.currentSortValue = 'modificationTime';
              $rootScope.damSortData.currentSortOrderValue = 'desc';
            }
          }
        } else if (queryData.physicalPages !== 'true') {
          var _sortBy = sortBy !== undefined ? sortBy : $rootScope.damSortData.currentSortValue;
          $rootScope.damSortData.currentSortValue = _sortBy;
          var _sortOrder = sortOrder !== undefined ? sortOrder : $rootScope.damSortData.currentSortOrderValue;
          $rootScope.damSortData.currentSortOrderValue = _sortOrder;
          if (_sortBy && _sortOrder) {
            transferInfo['sort'] = _sortBy + " " + _sortOrder;
          }
        } else if (queryData.physicalPages === 'true') {
          if (transferInfo.rows > 0) {
            transferInfo['sort'] = ((sortBy !== undefined) ? sortBy : "pageSequence_atex_desk_i") + " " + ((sortOrder !== undefined) ? sortOrder : "asc");
          }
        }

        //----------------
        //sorter for bdget view
        if (queryData.budgetView || $rootScope.listBudget){
          var _sortByBudget = sortBy !== undefined ? sortBy : $rootScope.damSortData.currentSortValue;
          $rootScope.damSortData.currentSortValue = _sortByBudget;
          var _sortOrderBudget = sortOrder !== undefined ? sortOrder : $rootScope.damSortData.currentSortOrderValue;
          $rootScope.damSortData.currentSortOrderValue = _sortOrderBudget;
          if (_sortByBudget && _sortOrderBudget) {
            // Support for multiple sorts
            var sortArray = _sortByBudget.split(',');
            var sortStatement = [];
            for(var i = 0, l = sortArray.length; i < l; i++) {
              if(sortArray.length === 2 && sortArray[0] === "tvpublishingtime_atex_desk_dt" && sortArray[1] === "relevance_atex_desk_s"){
                sortStatement[0] = sortArray[0] + " asc";
                sortStatement[1] = sortArray[1] + " desc";
                break;
              }
              else if (sortArray[i] === "desk_atex_desk_i" && sortArray[i+1] === "digitalpublishingtime_atex_desk_dt") {
                sortStatement[0] = sortArray[i] + " asc";
                sortStatement[1] = sortArray[i+1] + " asc";
                break;
              } else if ((sortArray[i] === "desk_atex_desk_i" && sortArray[i+1] === "relevance_atex_desk_s") || (sortArray[i] === "digitalpublishingtime_atex_desk_dt" && sortArray[i+1] === "relevance_atex_desk_s")) {
                sortStatement[0] = sortArray[i] + " asc";
                sortStatement[1] = sortArray[i+1] + " desc";
                break;
              } else {
                sortStatement[0] = sortArray[i] + " " + _sortOrderBudget;
              }
            }
            transferInfo['sort'] = sortStatement.join(',');
            transferInfo['TZ'] = 'America/New_York';
          }
        }
        //----------------

        if (start === 0) {
          transferInfo['trace'] = 'searchAdvanced';
        } else {
          transferInfo['trace'] = 'searchAdvancedMoreResults';
        }

        if (isLoadMore && $rootScope.lastQueryStartDate && queryData.isDynamic !== 'true') {
          transferInfo['q'] += '-originalCreationTime_dt:[' + $rootScope.lastQueryStartDate + ' TO *]';
        }

        $rootScope.lastSolrQuery = transferInfo['q']; // stored to append faceting

        return SearchService.search(transferInfo).then(function (result) {
          if (queryData.physicalPages === "true" && rows === undefined) {
            var _rows = atex.onecms.ObjectUtils.getByPath(result, "data/response/numFound");
            return DamService.getResults(queryData, start, filterQuery, sortBy, sortOrder, dynamicLoadMoreFilterQuery, _rows);
          } else {
            $rootScope.$broadcast("dam:afterExecuteQuery", queryData.isDynamic === 'true' ? true : false);
            return $q.when(result);
          }
        }).then(null, function (error) {
          console.log('ERROR: DamService getResults:', error);
          $rootScope.$broadcast("dam:afterExecuteQuery");
          return $q.reject(error);
        });
      });
    },

    /*
     * This is called to retrieve result for dynamic searches fq parameter:
     * beware FilterQuery it is intended to be used for faceting purposes
     * and for dynamic query update condition (setting the correct timestamp
     * filter)
     */
    updateResults : function(queryData, start, filterQuery) {
      return DamService.getSolrServerInfo().then(function(solrInfo) {
        if (start <= 0) {
          $rootScope.lastAdvQueryData = queryData;
        }

        var queryInfo = getUpdateResultsInfo();

        addAtexDeskVersion(queryInfo);

        var transferInfo = {};
        for ( var k in queryInfo) {
          transferInfo[k] = queryInfo[k];
        }
        if (solrInfo.solrLatestCore) {
          transferInfo['core'] = solrInfo.solrLatestCore;
        } else {
          transferInfo['core'] = solrInfo.solrCore;
        }

        if (queryData.solr_query !== '') {
          transferInfo['q'] = queryData.solr_query;
        } else {
          transferInfo['q'] = '*:* ';
        }
        transferInfo['rows'] = 60;
        transferInfo['start'] = start;
        if (filterQuery) {
          transferInfo['fq'] = filterQuery;
        }

        if (queryData.includeTrash!=='true') {
          transferInfo['fq'] += configuration.getQueryFilterTrash();
        }

        transferInfo['sort'] = "atex_desk_version desc";

        if(queryData.physicalPages === "true") {
          transferInfo['variant'] = 'ppage';
        }

        $rootScope.lastSolrQuery = transferInfo['q']; // stored to append faceting
        return SearchService.search(transferInfo);
      });
    },
    /*
     * This is the simple search full text only.
     */
    getFullText : function(query, start) {
      return DamService.getSolrServerInfo().then(function(solrInfo) {
        var isLoadMore = start && start>0;
        if (start <= 0) {
          $rootScope.$broadcast("dam:startNewQuery");
          $rootScope.lastAdvQueryData = undefined;
          $rootScope.lastAdvFilterQuery = undefined;
          $rootScope.lastQueryStartDate = atex.dam.AngularUtils.toUTCDate(Date.now() - getTimestampShift());
        }
        $rootScope.$broadcast("dam:beforeExecuteQuery");

        var queryInfo = getQueryInfo();

        var transferInfo = {};
        for ( var k in queryInfo) {
          transferInfo[k] = queryInfo[k];
        }
        if ($rootScope.searchOptions && $rootScope.searchOptions.solrCoreSimpleSearch){
          transferInfo['core'] = $rootScope.searchOptions.solrCoreSimpleSearch;
        }else{
          transferInfo['core'] = solrInfo.solrCore;
        }

        var queryStr = DamService.normalizeQueryString(query);
        var targetTextField = '+atex_desk_text';
        if ($rootScope.searchOptions && $rootScope.searchOptions.solrCoreSimpleSearch){
          targetTextField = $rootScope.searchOptions.targetTextFieldSimpleSearch;
        }
        transferInfo['q'] = ((queryStr) ? (''+targetTextField+':('+queryStr+')') : '') + '+atex_desk_objectType:(' + allDeskObjType + ')-physicalPage_ss:true'+boostsObjectType;

        transferInfo['rows'] = DamService.getRows();
        transferInfo['start'] = start;

        // Full Text always filters trash content
        transferInfo['fq'] = configuration.getQueryFilterTrash();


        if(start === 0) {
          transferInfo['trace'] = 'searchFullText';
        } else {
          transferInfo['trace'] = 'searchFullTextMoreResults';
        }

        if ($rootScope.damSortData.currentSortValue && $rootScope.damSortData.currentSortOrderValue) {
          transferInfo['sort'] = $rootScope.damSortData.currentSortValue + " " + $rootScope.damSortData.currentSortOrderValue;
        }

        if (isLoadMore && $rootScope.lastQueryStartDate) {
          transferInfo['q'] += '-originalCreationTime_dt:[' + $rootScope.lastQueryStartDate + ' TO *]';
        }

        $rootScope.lastSolrQuery = transferInfo['q']; // stored to append faceting
        return SearchService.search(transferInfo).then(function(result) {
          $rootScope.$broadcast("dam:afterExecuteQuery");
          return $q.when(result);
        }).then(null, function(error) {
          console.log('ERROR: DamService getFullText:', error);
          $rootScope.$broadcast("dam:afterExecuteQuery");
          return $q.reject(error);
        });
      });
    },

    getFullTextQuery: function(queryStr) {
      return ((queryStr) ? ('+atex_desk_text:(' + queryStr + ')') : '') + emptyQuery;
    },

    /*
     * This is the search to retrieve faceting on fields belonging to
     * children object (publication events) This occurs for a simple search
     * where only a fullText query string has been defined In this case the
     * reverse_query is built inside the method, while for advanced searches
     * it is retrieved as a QueryBean property
     */
    getFullTextFacets : function(query) {
      return DamService.getSolrServerInfo().then(function(solrInfo) {
        var transferInfo = {};

        var facetQueryInfo = getExtraFacetQueryInfo();

        for ( var k in facetQueryInfo) {
          transferInfo[k] = facetQueryInfo[k];
        }
        transferInfo['core'] = solrInfo.solrCore;

        // Full Text always filters trash content
        transferInfo['fq'] = configuration.getQueryFilterTrash();

        var queryStr = DamService.normalizeQueryString(query, true);
        var reverse_query = '+atex_desk_inputTemplate:(p.DamPublEvent)+_query_:"{!child%20of=\'contentType_atex_desk_s:parentDocument\'}' +
            ((queryStr) ? ('+atex_desk_text:('+queryStr+')') : '') + emptyQuery + '"';

        transferInfo['q'] = reverse_query;
        transferInfo['rows'] = '0';
        transferInfo['start'] = '0';
        $rootScope.reverseSolrQuery = transferInfo['q']; // stored to append faceting
        return SearchService.search(transferInfo);
      });
    },

    /*
     * This is the search to retrieve faceting on fields belonging to
     * children object (publication events) This occurs for an advanced
     * search where the user can define more search parameters and the
     * search could have also a subquery on children. For such a use case,
     * the QueryBean has 2 properties: - solr_query (used for the main
     * search) - reverse_query (used for faceting purposes)
     *
     * Important Note: a query like: "give me all images where
     * editon=NEWSYORK", will be translated as
     * +edition_ss:("NEWYORK")+inputTemplate:(p.DamPublEvent)+_query_:"{!child
     * of='contentType_s:parentDocument'}(+inputTemplate:(p.DamImage))" in
     * the result set you will see records that belong to multiple editions.
     * So maybe a record that belong to NEWYORK, but also to NATIONAL
     * editon, because published on 2 different pages In this specifi case
     * you will see only 1 item under the Facet/edition field, which is
     * NEWYORK This is the correct behavior because the user searched for
     * edition=NEWYORK
     *
     * This is slightly different from the faceting that occurs on fields
     * like places, attributes and so on. Imagine a search like: "give me
     * all records where places=MILAN. Places is a multi-value field, so the
     * result set could contain a record about fashion weeks where
     * places=MILAN;PARIS;NEWYORK The faceting in this case will show
     * Places: MILAN(x) - PARIS(y) - NEWYORK(z) Here the difference is that
     * "places" is a multi-value field, while "edition" is a single value
     * field of a child element
     *
     */
    getAdvancedFacets : function(queryData, filterQuery) {
      return DamService.getSolrServerInfo().then(function(solrInfo) {
        var transferInfo = {};

        var facetQueryInfo = getExtraFacetQueryInfo();

        for ( var k in facetQueryInfo) {
          transferInfo[k] = facetQueryInfo[k];
        }
        transferInfo['core'] = solrInfo.solrCore;

        // If there is no clear indication that we want to query on all the archive
        // we try to use the solrLatestCore if any [max]
        if (solrInfo.solrLatestCore && queryData.onlyLatest) {
          transferInfo['core'] = solrInfo.solrLatestCore;
        }

        transferInfo['q'] = queryData.reverse_query;
        transferInfo['rows'] = '0';
        transferInfo['start'] = '0';
        if (filterQuery) {
          transferInfo['fq'] = filterQuery;
        }
        $rootScope.reverseSolrQuery = transferInfo['q']; // stored to append
        // faceting queries
        return SearchService.search(transferInfo);
      });
    },

    getFacetsValues : function(queryData, filterQuery) {
      return DamService.getSolrServerInfo().then(function(solrInfo) {
        var transferInfo = {};

        var facetQueryInfo = getFacetQueryInfo();

        for ( var k in facetQueryInfo) {
          transferInfo[k] = facetQueryInfo[k];
        }
        transferInfo['core'] = solrInfo.solrCore;

        transferInfo['q'] = queryData.solr_query;
        transferInfo['rows'] = '0';
        transferInfo['start'] = '0';
        if (filterQuery) {
          transferInfo['fq'] = filterQuery;
        }
        $rootScope.reverseSolrQuery = transferInfo['q']; // stored to append
        // faceting queries
        return SearchService.search(transferInfo);
      });
    },

    /*jslint bitwise: true */
    UUID : function() {
      var nbr, randStr = "";
      do {
        randStr += (nbr = Math.random()).toString(16).substring(2);
      } while (randStr.length < 30);
      return [ randStr.substring(0, 8), "-", randStr.substring(8, 4), "-4", randStr.substring(12, 3), "-", ((nbr * 4 | 0) + 8).toString(16), randStr.substring(15, 3),
          "-", randStr.substring(18, 12) ].join("");
    },
    /*jslint bitwise: false*/

    /*
     * This method returns a bean object retrieved by the QueryMapper The
     * bean object contains - solr_query (used for the main search) -
     * reverse_query (used for faceting purposes)
     */
    getQuery : function(queryContainer) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/solrquery";
        // Clean queryContainer.aspects.contentData.data from fields ending with '_element_types'
        // in order to avoid IndexOutOfBoundsException exception on server [max]
        for (var k in queryContainer.aspects.contentData.data) {
          if (k.endsWith('_element_types')) {
            delete queryContainer.aspects.contentData.data[k];
          }
        }

        var removeList = ["values", "clearValues", "readOnly", "forPrint"];

        removeList.forEach(function( member ) {
          if ( queryContainer.aspects.contentData.data[member] ) {
            delete queryContainer.aspects.contentData.data[member];
          }
        });

        return $http.post(url, queryContainer);
      });
    },

    changePassword: function(password) {
      return AuthenticationService.callWithAuthentication(function () {
        password = encodeURIComponent(password);
        var url = "/onecms/dam/content/changePassword?pwd=" + password;
        return $http({
          method: 'POST',
          url: url,
          headers: {
            'Content-Type': 'application/json'
          }
        });
      });
    },

    getTextMining : function(body) {
      return AuthenticationService.callWithAuthentication(function (currentUser) {
        var content = {body: body, plan: ""};
        var url = "/textmining/resources/metadata/annotation";
        return $http({
          method: 'POST',
          url: url,
          data: content,
          headers: {
            'Content-Type': 'application/json'
          }
        });
      });
    },

    getRelatedSearch : function(text) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var _text = DamService.escapeLucene(text);
        var url = "/onecms/dam/content/mlt?q=" + _text + configuration.getUrl();
        return $http({
          method : 'GET',
          url : encodeURI(url)
        });
      });
    },

    permission : function(obj) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/permission";
        return $http({
          method : 'POST',
          url : url,
          data: obj,
          headers : {
            'Content-Type' : 'application/json'
          }
        });
      });
    },

    createPrintVariantImage: function (contentId) {
      return AuthenticationService.callWithAuthentication(function (currentUser) {
        var url = "/onecms/dam/image/create-print-variant/" + encodeURIComponent(contentId);
        return $http({
          method : 'POST',
          url : url,
          headers : {
            'X-Auth-Token': currentUser.token,
            'Accept': 'application/json',
            'Content-Type' : 'application/json'
          }
        }).then(function(response) {
          return response.data.id;
        });
      });
    },

    addEngagementAspect : function(obj) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/addengagement";
        return $http({
          method : 'POST',
          url : url,
          data: obj,
          headers : {
            'Content-Type' : 'application/json'
          }
        });
      });
    },

    exportContent : function(contentId, _appName, inputTemplate, destination, status) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        return DamService.getUserDomains().then(function(domain) {
          var appName = _appName ? _appName : (inputTemplate === 'p.DamImage' ? 'atex.dm.archive' : null);
          appName = appName || Application.name || 'DamService';
          var url = '/onecms/dam/content/export' + '?contentId=' + encodeURIComponent(contentId) + '&appType=' + encodeURIComponent(appName);
          if (domain && domain.exportSites && domain.exportSites.length>0) {
            url += '&domain=' + encodeURIComponent(domain.exportSites[0].extId);
          }
          if (inputTemplate) {
            url += '&inputTemplate=' + encodeURIComponent(inputTemplate);
          }
          if (destination) {
            url += '&destination=' + encodeURIComponent(destination);
          }
          if (status) {
            url += '&status=' + encodeURIComponent(status);
          }

          return $http({
            method: 'GET',
            url: url,
            headers: {
              'Content-Type': 'text/plain'
            }
          });
        });
      });
    },

    clearEngage : function(contentId, _appName) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var appName = _appName || Application.name || 'DamService';
        var url = '/onecms/dam/content/clearEngage' + '?contentId=' + encodeURIComponent(contentId);
        return $http({
          method: 'GET',
          url: url,
          headers: {
            'Content-Type': 'text/plain'
          }
        });
      });
    },

    autocomplete: function(query,field) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var transferInfo = {};
        transferInfo['core'] = 'onecms';
        transferInfo['facet'] = true;
        transferInfo['rows'] = '0';
        transferInfo['q'] = '*:* ';
        transferInfo['facet.limit'] = "10";
        transferInfo['facet.mincount'] = "1";
        transferInfo['facet.field'] = field;
        transferInfo['facet.contains'] = query;
        transferInfo['facet.contains.ignoreCase'] = true;
        return SearchService.search(transferInfo).then(function(resp) {
          var terms = [];
          var facetFields = atex.onecms.ObjectUtils.getByPath(resp, "data/facet_counts/facet_fields");
          if (facetFields && facetFields[field]) {
            facetFields[field].forEach(function (term, key) {
              if (key % 2 === 0) {
                terms.push(term);
              }
            });
          }
          return terms;
        });
      });
    },

    publishContent : function(contentId) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/publish?contentId="+contentId;
        return $http({
          method : 'POST',
          url : url,
          headers : {
            'Content-Type' : 'text/plain'
          }
        });
      });
    },

    implementSchedule : function(contentId,extraInfo) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/scheduling/implementScheduleInstance";
        var content = { contentId: contentId, pubDate : extraInfo};
        return $http({
          method : 'POST',
          url : url,
          data : content,
          headers : {
            'Content-Type': 'application/json'
          }
        });
      });
    },

    unpublishContent : function(contentId) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/unpublish?contentId="+contentId;
        return $http({
          method : 'POST',
          url : url,
          headers : {
            'Content-Type' : 'text/plain'
          }
        });
      });
    },

    getGalleryUrl : function(contentId) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/galleryurl?contentId="+contentId;
          return $http({
            method : 'GET',
            url : encodeURI(url),
            headers : {
              'Content-Type' : 'text/plain'
            }
        });
      });
    },

    updateEntryCollectionMetadata : function(data) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var obj = {
            'aspects' : {
              'contentData' : data
            }
        };

        var url = "/onecms/dam/content/update";
        return $http({
          method : 'PUT',
          url : url,
          data: obj,
          headers : {
            'Content-Type' : 'application/json'
          }
        });
      });
    },

    getColorCodingMap : function() {
      var transferInfo = {
        'id' : 'dam.colorcoding.conf'
      };
      return ContentService.getContent(transferInfo);
    },

    getGalleryConfigurationsMap : function() {
      var transferInfo = {
        'id' : 'dam.galleryconfigurations.conf'
      };
      return ContentService.getContent(transferInfo);
    },

    getIconCodingMap : function() {
      var transferInfo = {
        'id' : 'dam.iconcoding.conf'
      };
      return ContentService.getContent(transferInfo);
    },

    getMultiIconCodingMap : function() {
      var transferInfo = {
        'id' : 'dam.multiiconcoding.conf'
      };
      return ContentService.getContent(transferInfo);
    },

    getSmartUpdatesRulesMap:function() {
      var transferInfo = { 'id': 'dam.smartupdates.conf' };
      return ContentService.getContent(transferInfo);
    },

    getSendContentRulesMap:function() {
      var transferInfo = { 'id': 'dam.sendcontent.conf' };
      return ContentService.getContent(transferInfo);
    },

    getExports:function() {
      var transferInfo = { 'id': 'dam.export.conf' };
      return ContentService.getContent(transferInfo);
    },

    getPartitions:function() {
      var transferInfo = { 'id': 'dam.partitions.conf' };
      return ContentService.getContent(transferInfo);
    },


    isMobileDevice : function(width) {
      if ($rootScope.isRunningTest) {
        return false;
      }

      if(!width) {
        width = 1200;
      }
      return ($window.innerWidth < width);
    },

    getSearchConfiguration : function(term) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = '/onecms/dam/content/configuration/search/';
        url = url + term.term;
        return $http.get(url);
      });
    },

    getSolrServerInfo : function() {
      if (_solrInfo === undefined) {
        _solrInfo = AuthenticationService.callWithAuthentication(function(currentUser) {
          var deferred = $q.defer();
          var url = '/onecms/dam/content/configuration/solrserverinfo/';
          $http.get(url).success(function(data, status, headers, config) {
              deferred.resolve(data);
          }).error(function(data, status, headers, config) {
              deferred.reject(data);
          });
          return deferred.promise;
        });
      }
      return _solrInfo;
    },

    /*
     * We are using a trick to bypass onecms-lib ContentService.getContent filter on request parameters
     * We need searchString into DamContentPreviewComposer to call highlight query on solr [max]
     */
    getHighLightedEntry : function(contentId, searchString) {
      var transferInfo = {
        id: contentId
      };
      if (searchString) {
        transferInfo.variant = 'preview&searchString=+atex_desk_text:(' + searchString + ')';
      } else {
        transferInfo.variant = 'preview';
      }
      return ContentService.getContent(transferInfo);
    },

    getCollections : function(contentId) {
      return DamService.getSolrServerInfo().then(function(solrInfo) {
        var transferInfo = {};
        transferInfo['core'] = solrInfo.solrCore;
        transferInfo['q'] = '+atex_desk_objectType:collection AND ';
        transferInfo['q'] = transferInfo['q'] + 'contents_atex_desk_sm:(' + DamService.escapeLucene(contentId) + ')';
        return SearchService.search(transferInfo);
      });
    },

    getUsers : function() {
      // getUsers was based on the deprecated /onecms/dam/content/users (that returns users + groups)
      // let's switch to the new getUsersAndGroups (that uses principals endpoint) [max]
      return this.getUsersAndGroups();
    },

    getUsersAndGroups : function () {
      if (typeof usersAndGroups === 'undefined') {
        var promises = [];
        promises.push(DamService.getPrincipals("users"));
        promises.push(DamService.getPrincipals("groups"));

        usersAndGroups = $q.all(promises).then(function (nestedusers) {
          return nestedusers.flat().sort(function (user1, user2) {
            if (typeof user1.name === 'undefined' || typeof user2.name === 'undefined') {
              return -1;
            } else if (user1.type === user2.type) {
              return user1.name.localeCompare(user2.name, undefined, {numeric: true, sensitivity: 'base'});
            } else {
              // groups compare before users
              return user1.type.localeCompare(user2.type);
            }
          });
        });
      }
      return usersAndGroups;
    },

    getPrincipals : function(type) {
      if (type === "users" && typeof users === 'undefined'){
        users = AuthenticationService.callWithAuthentication(function (currentUser) {
          var deferred = $q.defer();
          var url = "/onecms/principals/" + type;
          $http.get(url).then(function (response) {
            deferred.resolve(response.data);
          }).then(null, function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        });
      }
      if (type === "groups" && typeof groups === 'undefined'){
        groups = AuthenticationService.callWithAuthentication(function (currentUser) {
          var deferred = $q.defer();
          var url = "/onecms/principals/" + type;
          $http.get(url).then(function (response) {
            deferred.resolve(response.data);
          }).then(null, function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        });
      }
      if (type === "users") {
        return users;
      }
      if (type === "groups") {
        return groups;
      }
    },

    getUserInfo : function(userId) {
      return AuthenticationService.callWithAuthentication(function () {
        return $http.get("/onecms/principals/users/" + userId).then(function(response) {
          var user = response.data;
          user.firstname = user.firstName;
          user.lastname = user.lastName;
          return response;
        });
      });
    },

    loadCurrentDamUserInfo : function() {
      return AuthenticationService.getCurrentUserData().then(function(currentUser) {
          // fixup the result to make it compatible with the old desk api
          if (!currentUser.externalId) {
            currentUser.externalId = currentUser.userId;
          }
          if (currentUser.externalId === "98") {
            currentUser.isAdm = true;
          }
          return currentUser;
      });
    },

    getCurrentDamUserInfo : function() {
      if (currentUserInfo === undefined) {
        currentUserInfo = DamService.loadCurrentDamUserInfo();
      }
      return currentUserInfo;
    },

    sendSlackMessage : function(data) {
      return AuthenticationService.callWithAuthentication(function () {
        var url = "/onecms/dam/content/send.job.message.by.parameters";
        return $http.post(url, data);
      });
    },

    showContentPreview: function(contentId) {
        AuthenticationService.callWithAuthentication(function(currentUser) {
          var previewScope = $rootScope.$new(true);
          previewScope.id = contentId;

          var destroyModal = function() {
            modal.then(function(modalEl) {
            modalEl.on('hidden.bs.modal', function() {
              previewScope.$destroy();
              angular.element(this).remove();
            });
            modalEl.modal('hide');
         });
        };

          previewScope.doCancel = function() {
            destroyModal();
          };

          var modal = $modal({
          show : true,
          scope : previewScope,
          template : 'views/dam-preview-dialog.html',
          modalClass : 'dam-preview-dialog',
          backdrop : 'static',
          keyboard : false
          });
        });
    },

    loadReferences : function(contentId) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var deferred = $q.defer();
        var url = "/onecms/dam/content/references?contentId=" + encodeURIComponent(contentId);
        $http.get(url).then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      });
    },

    loadJobs : function(contentId) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var deferred = $q.defer();
        var url = "/onecms/dam/content/jobs?contentId=" + encodeURIComponent(contentId);
        $http.get(url).then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      });
    },


    loadRelated : function(id) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var deferred = $q.defer();
        var url = "/onecms/dam/content/related?id=" + encodeURIComponent(id);
        $http.get(url).then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      });
    },

    getWrappedContentId : function(onecmsid) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var deferred = $q.defer();
        var url = "/onecms/dam/content/getPolicyWrapper?onecmsid=" + encodeURIComponent(onecmsid);
        $http.get(url).then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      });
    },

    deleteContent : function(contentId, isTrashVisible) {
      var deferred = $q.defer();
      ContentService.getContent({ id: contentId }).then(function(object) {
        // Set securityParentId as trash
        object.data.aspects['contentData'].data.securityParentId = object.data.aspects['p.InsertionInfo'].data.securityParentId;
        object.data.aspects['p.InsertionInfo'].data.securityParentId = configuration.getTrashId();
        object.data.aspects['p.InsertionInfo'].data.insertParentId = object.data.aspects['p.InsertionInfo'].data.securityParentId;
        var transferInfo = { id: object.id, data: object.data, revision: object.revision};
        ContentService.updateContent(transferInfo).then(function(response) {
          deferred.resolve(response);
          if (isTrashVisible) {
            // The user can see the trashId
            ContentService.getContent({ id: contentId, variant: 'preview' }).then(function(object) {
              atex.dam.AngularUtils.fixUrls(object.data);
              $rootScope.$broadcast('dam:itemLogicalDeleted', object);
            }).then(null, function(error) {
              $rootScope.$broadcast("dam:itemDeleted", object.id);
            });
          } else {
            $rootScope.$broadcast("dam:itemDeleted", object.id);
          }
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }).then(null, function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    },

    undeleteContent : function(contentId) {
      var deferred = $q.defer();
      ContentService.getContent({ id: contentId }).then(function(object) {
        // Set securityParentId as trash
        object.data.aspects['p.InsertionInfo'].data.securityParentId = object.data.aspects['contentData'].data.securityParentId; //'externalid/dam.assets.common.d';
        object.data.aspects['p.InsertionInfo'].data.insertParentId = object.data.aspects['p.InsertionInfo'].data.securityParentId;
        var transferInfo = { id: object.id, data: object.data, revision: object.revision};
        ContentService.updateContent(transferInfo).then(function(response) {
          deferred.resolve(response);
          $rootScope.$broadcast('dam:updatedItem', {id: contentId});
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }).then(null, function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    },

    addCamelRoute : function(fromUri, toUri) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/addCamelRoute";
        return $http.post(url, {"fromUri":fromUri, "toUri":toUri});
      });
    },

    removeCamelRoute : function(id) {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/stopCamelRoute";
        return $http.post(url, {"routeId":id});
      });
    },

    getCamelRoutes : function() {
      return AuthenticationService.callWithAuthentication(function(currentUser) {
        var url = "/onecms/dam/content/camelRoutes?userId=" + currentUser.principalId;
        return $http.get(url);
      });
    },

    getAspectFromTemplate : function(template) {
      return AuthenticationService.callWithAuthentication(function() {
        var deferred = $q.defer();
        var url = "/onecms/dam/content/sked/aspect?template=" + template;

        $http.get(url).then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      });
    },

    duplicate: function(entries) {
      return AuthenticationService.callWithAuthentication(function () {
        var deferred = $q.defer();
        var url = "/onecms/dam/content/duplicate";

        $http.put(url, {"entries": entries}).then(function (duplicated) {
          deferred.resolve(duplicated.data);
        }, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      });
    },

    //Remove extra spaces and add AND between terms
    normalizeQueryString: function(queryStr, faceting, queryOperator) {
      if (!queryStr) {
        return '';
      }
      var _queryStr = DamService.escapeLucene(queryStr.trim(), faceting);
      var normalizedQuery = _queryStr.replace(/\s+/g, ' ');
      if (!configuration.getQueryTermsInAnd() || normalizedQuery.indexOf(' AND ') > 0 ||
        normalizedQuery.indexOf(' OR ') > 0 || normalizedQuery.indexOf(' NOT ') > 0) {
        return normalizedQuery;
      }
      if (queryOperator !== undefined && queryOperator !== ""){
        return normalizedQuery.replace(/\s(?=(?:(?:[^"]*"){2})*[^"]*$)/g, ' ' + queryOperator + ' ');
      }else{
        return normalizedQuery.replace(/\s(?=(?:(?:[^"]*"){2})*[^"]*$)/g, ' AND ');
      }
    },

    getUserDomains: function() {
      if (currentUserDomains) {
        return $q.when(currentUserDomains);
      }
      return UserProfileService.getConfigurationById({
        application:'desk',
        id: 'domain'
      }).then(function(profile) {
        currentUserDomains = [];
        if (profile) {
          currentUserDomains = profile;
        }
        return $q.when(currentUserDomains);
      });
    },

    changePrintPageStatus: function( contentId, statusId, comment, assignees ) {
      return AuthenticationService.callWithAuthentication(function () {
        return AuthenticationService.getCurrentUser().then(function(currentUser) {
          var deferred = $q.defer();
          var url = '/onecms/layout/handj/content/changepagestatus/' + contentId +
            '?statusid=' + statusId;
          if (typeof comment === 'string') {
            url += '&comment=' + encodeURIComponent(comment);
          }
          if (typeof assignees === 'string') {
            url += '&assignees=' + encodeURIComponent(assignees);
          }
          url += '&update=1';
          if (currentUser && currentUser.username) {
            url += '&userName=' + currentUser.username;
          }
          $http.get(url).then(function (resp) {
            deferred.resolve(resp);
          }, function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        });
      });
    },

    restorePrintContent: function(version, elementName, restoreWeb) {
      return AuthenticationService.callWithAuthentication(function (currentUser) {
        var url = '/onecms/layout/handj/content/restore/article?version=' + version;
        url += '&userName=' + encodeURIComponent(currentUser.username);
        if (elementName) {
          url += '&elementName=' + elementName;
        }
        if (restoreWeb) {
          url += '&restoreWeb=true';
        }
        return $http.post(url);
      });
    },

    getActualPrintContent: function(articleId) {
      return AuthenticationService.callWithAuthentication(function (currentUser) {
        var url = '/onecms/layout/handj/content/print/' + articleId + '?userId=' + currentUser.principalId + '&userName=' +
          encodeURIComponent(currentUser.username) + '&lock=false';
        return $http.get(url);
      });
    }

  };

  return DamService;

});

angular.module('atex.dam').directive('draggable', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('dragstart', scope.handleDragStart);
      element.on('dragend', scope.handleDragEnd);
    }
  };
});

angular.module('atex.dam').directive('droppable', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('drop', scope.handleDrop);
      element.on('dragover', scope.handleDragOver);
    }
  };
});

angular.module('atex.dam').directive('keyTrap', function() {
  return function(scope, elem) {
    elem.bind('keydown', function(event) {
      scope.$broadcast('keydown', event.keyCode, event);
    });
  };
});

angular.module('atex.dam').directive('drawerDraggable', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('dragstart', scope.handleDowerDragStart);
      element.on('dragend', scope.handleDowerDragEnd);
    }
  };
});
angular.module('atex.dam').directive('drawerDroppable', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('drop', scope.handleDowerDrop);
      element.on('dragover', scope.handleDowerDragOver);
    }
  };
});

angular.module('atex.dam').directive('leftSideDragover', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('dragover', scope.handleLeftSideDragOver);
    }
  };
});

angular.module('atex.dam').directive('foldersHeadingDragover', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('dragover', scope.handleFoldersHeadingDragOver);
    }
  };
});

angular.module('atex.dam').directive('drawerDragover', function() {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.on('dragover', scope.handleDrawerDragOver);
    }
  };
});

// This is just a Debug directive to check time to render ng-repeat [max]
angular.module('atex.dam').directive('postRepeatDirective', [ '$timeout', '$rootScope', function($timeout, $rootScope) {
  return function(scope) {
    if (scope.$first) {
      window.a = new Date();
    }
    // window.a can be updated anywhere if to reset counter at some action if
    // ng-repeat is not getting started from $first
    if (scope.$last) {
      $timeout(function() {
        console.log("## DOM rendering list took: " + (new Date() - window.a) + " ms");
      });
    }
  };
} ]);

angular.module('atex.dam').directive('damAdvSearchPopover', function($rootScope, $compile, $templateCache, $http, $window, $translate, UIConfigurationService, PreloadService, UserProfileService, DamNotificationService) {
  var createPopover = function(el, popOverContent, placementAttr, template) {
    el.popover({
      trigger : 'manual',
      html : true,
      content : popOverContent,
      container : "body",
      zIndex : '-1',
      placement : placementAttr,
      template: template,
    }).on('shown.bs.popover', function() {
      $('.dam-adv-search-popover').on('scroll', function() {
        $('.bootstrap-datetimepicker-widget').css('display','none');
        // In case in am scrolling on the search popover and I am focusing on a multiple select component
        // I force a click event outside of it to force it's close event.
        if (document.activeElement.className.indexOf("ui-select-search") >= 0){
          $('body').click();
        }
      });
      $rootScope.$broadcast('dam:advancedsearchloaded', undefined);
      angular.element($window).bind('resize', function() {
        $('.bootstrap-datetimepicker-widget').css('display','none');
      });
    });
  };

  return {
    restrict : 'A',
    link : function(scope, el, attrs) {
      function getTemplate() {
        var template = '<div class="popover dam-adv-search-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>';

        if (attrs.popoverTemplate) {
          template = '<div class="popover dam-adv-search-popover use-custom-template" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>';
        }

        return template;
      }
      UserProfileService.getUserProfile({"application": "desk"}).then(function (configuration) {
        PreloadService.preloadFactoryList('deskList').then(function () {
          $rootScope.popoverTemplate = atex.onecms.ObjectUtils.getByPath(configuration, 'data/search-forms/search-form/advancedPopoverTemplate') || 'views/dam-tab-search.html';
          var template = attrs.popoverTemplate || $rootScope.popoverTemplate || 'views/dam-tab-search.html';
          var html = $templateCache.get(template);
          var popOverContent = $compile(html)(scope);
          createPopover(el, popOverContent, attrs.popoverPlacement, getTemplate());
          el.click(function () {
            if ($('.popover .dam-search-form').length <= 0) {
              createPopover(el, popOverContent, attrs.popoverPlacement, getTemplate());
              el.popover('show');
              UIConfigurationService.getSearchOptions().then(function (options) {
                atex.dam.AngularUtils.highlightInputFields(atex.onecms.ObjectUtils.getByPath(options, 'defaultHighlightInputCss') || "");
              });
            } else {
              el.popover('destroy');
            }
          });
        });
      }).then(null, function (error) {
        var message = $translate.getTranslationTable().__PROFILE_ERROR__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });

      scope.$on("dam:initSearch", function () {
        if ($('.popover .dam-search-form').length > 0) {
          el.popover('destroy');
        }
      });
      scope.$on("dam:hideAdvanced", function () {
        if ($('.popover .dam-search-form').length > 0) {
          el.popover('destroy');
        }
      });

    }
  };
});
// To close the advanced search popover on mouseup
$('html').on('mousedown', function(e) {
  var ignore = false;
  var paths = atex.onecms.ObjectUtils.getByPath(e, 'originalEvent/path') || (e.originalEvent && e.originalEvent.composedPath && e.originalEvent.composedPath());
  _.each(paths, function (path) {
    if ($(path).hasClass('do-not-close')) {
      ignore = true;
    }
  });

  if (!ignore && $(e.target).closest('.popover').length <= 0 && $(e.target).closest('#ui-datepicker-div').length <= 0 && $('#dam-map-picker-modal').length <= 0 && $('#dam-sites-picker-modal').length <= 0) {
    $('.dam-adv-search-popover').each(function () {
      $(this).popover('destroy');
    });
  }
});

angular.module('atex.dam').directive('damFoldersPopover', function($rootScope, $compile, $templateCache, $http) {
  var createPopover = function(el, popOverContent, placementAttr) {
    el.popover({
      trigger : 'manual',
      html : true,
      content : popOverContent,
      container : "body",
      zIndex : '-1',
      placement : placementAttr,
      template: '<div class="popover dam-folders-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    });
  };

  return {
    restrict : 'A',
    link : function(scope, el, attrs) {
      var html = $templateCache.get("views/dam-folders-popover.html");
      var popOverContent = $compile(html)(scope);
      createPopover(el, popOverContent, attrs.popoverPlacement);
      el.click(function() {
        if ($('.popover #dam-folders').length <= 0) {
          createPopover(el, popOverContent, attrs.popoverPlacement);
          el.popover('show');
        } else {
          el.popover('destroy');
        }
      });
      scope.$on("dam:initSearch", function() {
        if ($('.popover #dam-folders').length > 0) {
          el.popover('destroy');
        }
      });
    }
  };
});
//To close the folders popover on mouseup
$('html').on('mousedown', function(e) {
  if ($(e.target).closest('.popover').length <= 0 && $(e.target).closest('#ui-datepicker-div').length <= 0 && $(".modal-backdrop.in").length <= 0) {
    $('.dam-folders-popover').each(function() {
      $(this).popover('destroy');
    });
  }
});

Array.prototype.equals = function(array) {
  // if the other array is a falsy value, return
  if (!array) {
    return false;
  }
  // compare lengths - can save a lot of time
  if (this.length !== array.length) {
    return false;
  }
  for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i])) {
        return false;
      }
    } else if (this[i] !== array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};

Array.prototype.ArrayIndexOf = function(fnc) {
  if (!fnc || typeof (fnc) !== 'function') {
    return -1;
  }
  if (this.length < 1) {
    return -1;
  }
  for (var i = 0; i < this.length; i++) {
    if (fnc(this[i])) {
      return i;
    }
  }
  return -1;
};

if (typeof String.prototype.startsWith !== 'function') {
  String.prototype.startsWith = function(searchString, position){
    position = position || 0;
    return this.substring(position, searchString.length) === searchString;
  };
}
if (typeof String.prototype.endsWith !== 'function') {
  String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
  };
}
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement /*, fromIndex*/) {
    if (this === null) {
      throw new TypeError('Array.prototype.includes called on null or undefined');
    }
    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {k = 0;}
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement ||
        (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}

angular.module('atex.dam').directive('damPoster', function() {
  return {
    priority: 99, // it needs to run after the attributes are interpolated
    link: function(scope, element, attr) {
      attr.$observe('damPoster', function(value) {
        if (!value) {
          return;
        }
        attr.$set('poster', value);
      });
    }
  };
});

angular.module('atex.dam').directive('ngReallyClick', ['ArtConfirmModal', '$timeout', function(ArtConfirmModal, $timeout) {
  return {
    restrict : 'A',
    link : function(scope, element, attrs) {
      element.bind('click', function() {
        var message = attrs.ngReallyMessage;
        if (message) {
          var confirmModal = ArtConfirmModal.create({
            confirmHeader: 'Confirm!',
            confirmBody: message,
            mode: 'danger'
          });
          confirmModal.then(function(confirmed) {
            if (confirmed) {
              $timeout(function(){
                scope.$apply(attrs.ngReallyClick);
              });
            }
          });
        } else {
          scope.$apply(attrs.ngReallyClick);
        }
      });
    }
  };
}]);

angular.module('atex.dam').directive('focusMe', function($timeout) {
  return {
    link: function(scope, element, attrs) {
      $timeout(function() {
        element[0].focus();
      });
    }
  };
});

// The following service 'PreviousState' is a temp fix to allow a correct back button behaviour (see edit-controller.js)
// see https://github.com/angular-ui/ui-router/pull/1845 for future updates on this topic
// and http://stackoverflow.com/questions/30303567/angularjs-get-previous-url-path-from-page for the following hack
angular.module('atex.dam').factory('PreviousState', ['$rootScope', '$state', function ($rootScope, $state) {
  var lastHref = "/", lastStateName = "list", lastParams = {};
  $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
    lastStateName = fromState.name;
    lastParams = fromParams;
  });

  return {
    goToLastState : function() {
      return $state.go(lastStateName, lastParams);
    },
    getLastStateName : function() {
      return lastStateName;
    },
    getLastParams : function() {
      return lastParams;
    }
  };

}]);

angular.module('atex.dam').filter('limitHtml', function() {
  return function(text, limit, postfix) {
    var changedString = String(text).replace(/(<\/a>|<a[^>]+>)/gm, '');
    return changedString.length <= limit ? changedString : changedString.substring(0, limit - 1) + postfix;
  };
});

jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
    this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
  }
};
